// ========== 高频词条系统 ==========
// 不绑套装，只绑品级和数量
// rare+装备掉落时随机获得1-2个词条
// 根据已装备rare+件数激活不同层级词条池

export const AFFIX_POOLS = {
  // 3件rare+装备激活
  common: [
    { id:'af_sturdy', name:'铁壁', desc:'防御+2', tier:'common', stat:'def', val:2 },
    { id:'af_sharp', name:'锐利', desc:'攻击+2', tier:'common', stat:'atk', val:2 },
    { id:'af_swift', name:'迅捷', desc:'速度+2', tier:'common', stat:'spd', val:2 },
    { id:'af_vitality', name:'活力', desc:'HP上限+25', tier:'common', effect:'hp_boost', val:25 },
    { id:'af_wealth', name:'聚财', desc:'金币掉落+5%', tier:'common', effect:'gold_bonus', val:0.05 },
    { id:'af_hardened', name:'硬化', desc:'受到伤害-2', tier:'common', effect:'dmg_reduce', val:2 },
    { id:'af_regen', name:'愈合', desc:'每回合恢复2HP', tier:'common', effect:'hp_regen', val:2 },
    { id:'af_brute', name:'蛮力', desc:'力量+1', tier:'common', stat:'str', val:1 },
    { id:'af_wisdom', name:'聪慧', desc:'智力+1', tier:'common', stat:'int', val:1 },
    { id:'af_lucky', name:'幸运', desc:'装备掉落率+5%', tier:'common', effect:'drop_bonus', val:0.05 },
    { id:'af_focused', name:'专注', desc:'技能消耗-1', tier:'common', effect:'mp_save', val:1 },
    { id:'af_durable', name:'持久', desc:'疲劳消耗-1', tier:'common', effect:'fatigue_save', val:1 },
  ],
  // 5件rare+装备激活
  advanced: [
    { id:'af_berserk', name:'狂战士', desc:'HP<30%时ATK+10%', tier:'advanced', effect:'low_hp_atk', val:0.10 },
    { id:'af_counter', name:'反击', desc:'受击8%概率反击(30%伤害)', tier:'advanced', effect:'counter', val:0.08, subVal:0.30 },
    { id:'af_leech', name:'吸血', desc:'造成伤害的2%回复HP', tier:'advanced', effect:'lifesteal', val:0.02 },
    { id:'af_cd_reduce', name:'冷却缩减', desc:'技能CD-1回合', tier:'advanced', effect:'cd_reduce', val:1 },
    { id:'af_pierce', name:'破甲', desc:'攻击8%概率无视30%防御', tier:'advanced', effect:'pierce', val:0.08, subVal:0.30 },
    { id:'af_shield', name:'护盾', desc:'战斗开始获得8%HP护盾', tier:'advanced', effect:'shield', val:0.08 },
    { id:'af_onslaught', name:'猛攻', desc:'连续攻击同目标伤害+3%(可叠3层)', tier:'advanced', effect:'onslaught', val:0.03, maxStack:3 },
    { id:'af_mp_regen', name:'冥想', desc:'每回合恢复2MP', tier:'advanced', effect:'mp_regen', val:2 },
    { id:'af_resist', name:'元素抗性', desc:'异常抗性+12%', tier:'advanced', effect:'resist', val:0.12 },
    { id:'af_endurance', name:'耐力', desc:'最大MP+10', tier:'advanced', effect:'mp_boost', val:10 },
    { id:'af_ferocity', name:'凶暴', desc:'暴击伤害+15%', tier:'advanced', effect:'crit_dmg', val:0.15 },
  ],
  // 8件rare+装备激活
  rare: [
    { id:'af_crit', name:'致命一击', desc:'6%概率1.5倍伤害', tier:'rare', effect:'crit', val:0.06, subVal:1.5 },
    { id:'af_indomitable', name:'不屈意志', desc:'HP<20%时获得一次50%减伤', tier:'rare', effect:'indomitable', val:0.50 },
    { id:'af_double', name:'双重打击', desc:'4%概率追加一次攻击(40%伤害)', tier:'rare', effect:'double_strike', val:0.04, subVal:0.40 },
    { id:'af_heal_kill', name:'战场治疗', desc:'击杀敌人恢复8%HP', tier:'rare', effect:'heal_on_kill', val:0.08 },
    { id:'af_slayer', name:'弱点感知', desc:'对精英/Boss伤害+5%', tier:'rare', effect:'slayer', val:0.05 },
    { id:'af_evade', name:'闪避', desc:'6%概率完全回避攻击', tier:'rare', effect:'evade', val:0.06 },
    { id:'af_skill_power', name:'技能强化', desc:'技能伤害+8%', tier:'rare', effect:'skill_power', val:0.08 },
    { id:'af_rage', name:'愤怒', desc:'每损失10%HP，ATK+1.5', tier:'rare', effect:'rage', val:0.015 },
    { id:'af_conserve', name:'节能', desc:'技能MP消耗-2', tier:'rare', effect:'mp_save_large', val:2 },
  ],
  // 史诗装备额外解锁
  epic: [
    { id:'af_execute', name:'处决', desc:'对HP<15%敌人伤害+20%', tier:'epic', effect:'execute', val:0.20 },
    { id:'af_fate', name:'命运逆转', desc:'死亡时6%概率以15%HP存活(每场1次)', tier:'epic', effect:'fate', val:0.06, subVal:0.15 },
    { id:'af_carnage', name:'杀戮盛宴', desc:'击杀后ATK+8%持续2回合(可刷新)', tier:'epic', effect:'carnage', val:0.08 },
    { id:'af_warp', name:'时间扭曲', desc:'技能CD-2(最低1)', tier:'epic', effect:'cd_reduce_large', val:2 },
    { id:'af_soul_link', name:'灵魂链接', desc:'造成伤害的2%回复MP', tier:'epic', effect:'soul_link', val:0.02 },
    { id:'af_last_stand', name:'最后的壁垒', desc:'HP<10%时无敌1回合(每场1次)', tier:'epic', effect:'last_stand', val:0.10 },
    { id:'af_elemental', name:'元素爆发', desc:'技能伤害+12%', tier:'epic', effect:'skill_power_epic', val:0.12 },
  ],
};

// 根据稀有度分配词条数
export function rollAffixesForItem(tier) {
  const tierMap = { rare:1, unique:2, epic:3 };
  const count = tierMap[tier] || 0;
  if(count === 0) return [];
  
  const affixes = [];
  for(let i = 0; i < count; i++) {
    // 从common池随机抽（高级词条由装备件数激活）
    const commonPool = AFFIX_POOLS.common;
    const af = commonPool[Math.floor(Math.random() * commonPool.length)];
    // 30%概率从advanced池抽（仅unique/epic）
    if(tier !== 'rare' && Math.random() < 0.3) {
      const advPool = AFFIX_POOLS.advanced;
      const advAf = advPool[Math.floor(Math.random() * advPool.length)];
      // 确保不重复
      if(!affixes.find(a => a.id === advAf.id)) {
        affixes.push(advAf);
        continue;
      }
    }
    if(!affixes.find(a => a.id === af.id)) {
      affixes.push(af);
    }
  }
  return affixes;
}

// 获取已装备rare+装备的件数
export function getEquippedRarePlusCount() {
  if(!window.S || !window.S.inventory) return 0;
  return window.S.inventory.filter(inv => 
    inv && inv.type === 'equip' && inv.equipped && 
    ['rare','unique','epic'].includes(inv.tier)
  ).length;
}

// 获取已装备史诗装备件数
export function getEquippedEpicCount() {
  if(!window.S || !window.S.inventory) return 0;
  return window.S.inventory.filter(inv =>
    inv && inv.type === 'equip' && inv.equipped &&
    inv.tier === 'epic'
  ).length;
}

// 获取所有已激活词条（基于装备件数激活层级）
export function getActiveAffixes() {
  const rareCount = getEquippedRarePlusCount();
  const epicCount = getEquippedEpicCount();
  if(rareCount < 3) return [];
  
  const active = [];
  
  // 收集所有装备上的词条
  const allAffixes = [];
  if(window.S && window.S.inventory) {
    window.S.inventory.forEach(inv => {
      if(inv && inv.type === 'equip' && inv.equipped && inv.affixes) {
        inv.affixes.forEach(af => allAffixes.push(af));
      }
    });
  }
  
  // 按层级筛选：遍历每个词条，检查是否达到对应层级
  allAffixes.forEach(af => {
    if(!af || !af.tier) return;
    const tier = af.tier;
    if(tier === 'common' && rareCount >= 3) active.push(af);
    if(tier === 'advanced' && rareCount >= 5) active.push(af);
    if(tier === 'rare' && rareCount >= 8) active.push(af);
    if(tier === 'epic' && epicCount >= 1) active.push(af);
  });
  
  // 去重
  const seen = new Set();
  return active.filter(af => {
    const key = af.id;
    if(seen.has(key)) return false;
    seen.add(key);
    return true;
  });
}

// 汇总激活词条效果
export function getAffixEffects() {
  const affixes = getActiveAffixes();
  const effects = {
    atk: 0, def: 0, spd: 0, str: 0, int: 0,
    hpBoost: 0, mpBoost: 0,
    goldBonus: 0, dropBonus: 0,
    dmgReduce: 0, hpRegen: 0, mpRegen: 0,
    lifesteal: 0, soulLink: 0,
    critChance: 0, critDmg: 0,
    doubleStrike: 0, doubleDmg: 0,
    evade: 0, counter: 0, counterDmg: 0,
    pierce: 0, piercePct: 0,
    slayer: 0, skillPower: 0,
    execute: 0, cdReduce: 0,
    onslaught: 0, onslaughtMax: 0,
    shield: 0, resist: 0,
    rage: 0, indomitable: 0,
    healOnKill: 0, fatigueSave: 0,
    lowHpAtk: 0, fate: 0, fateHp: 0,
    lastStand: 0, carnage: 0,
    mpSave: 0,
  };
  
  affixes.forEach(af => {
    if(af.stat) effects[af.stat] += af.val;
    if(af.effect === 'hp_boost') effects.hpBoost += af.val;
    if(af.effect === 'mp_boost') effects.mpBoost += af.val;
    if(af.effect === 'gold_bonus') effects.goldBonus += af.val;
    if(af.effect === 'drop_bonus') effects.dropBonus += af.val;
    if(af.effect === 'dmg_reduce') effects.dmgReduce += af.val;
    if(af.effect === 'hp_regen') effects.hpRegen += af.val;
    if(af.effect === 'mp_regen') effects.mpRegen += af.val;
    if(af.effect === 'lifesteal') effects.lifesteal += af.val;
    if(af.effect === 'soul_link') effects.soulLink += af.val;
    if(af.effect === 'crit') { effects.critChance += af.val; effects.critDmg = (af.subVal || 1.5); }
    if(af.effect === 'double_strike') { effects.doubleStrike += af.val; effects.doubleDmg = (af.subVal || 0.4); }
    if(af.effect === 'evade') effects.evade += af.val;
    if(af.effect === 'counter') { effects.counter += af.val; effects.counterDmg = (af.subVal || 0.3); }
    if(af.effect === 'pierce') { effects.pierce += af.val; effects.piercePct = (af.subVal || 0.3); }
    if(af.effect === 'slayer') effects.slayer += af.val;
    if(af.effect === 'skill_power') effects.skillPower += af.val;
    if(af.effect === 'skill_power_epic') effects.skillPower += af.val;
    if(af.effect === 'execute') effects.execute += af.val;
    if(af.effect === 'cd_reduce') effects.cdReduce += af.val;
    if(af.effect === 'cd_reduce_large') effects.cdReduce += af.val;
    if(af.effect === 'onslaught') { effects.onslaught += af.val; effects.onslaughtMax = (af.maxStack || 3); }
    if(af.effect === 'shield') effects.shield += af.val;
    if(af.effect === 'resist') effects.resist += af.val;
    if(af.effect === 'rage') effects.rage += af.val;
    if(af.effect === 'indomitable') effects.indomitable += af.val;
    if(af.effect === 'heal_on_kill') effects.healOnKill += af.val;
    if(af.effect === 'fatigue_save') effects.fatigueSave += af.val;
    if(af.effect === 'low_hp_atk') effects.lowHpAtk += af.val;
    if(af.effect === 'fate') { effects.fate += af.val; effects.fateHp = (af.subVal || 0.15); }
    if(af.effect === 'last_stand') effects.lastStand += af.val;
    if(af.effect === 'carnage') effects.carnage += af.val;
    if(af.effect === 'mp_save') effects.mpSave += af.val;
    if(af.effect === 'mp_save_large') effects.mpSave += af.val;
    if(af.effect === 'crit_dmg') effects.critDmg += af.val;
  });
  
  return effects;
}
